export default function CloseIcon(props) {
  const { width='19', height='19', fill='#2e2e2e' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 19.625 19.625">
      <g id="icon-close" transform="translate(-3.375 -3.375)">
        <path id="Trazado_1" data-name="Trazado 1" d="M13.188,5.356A7.828,7.828,0,1,1,7.649,7.649a7.8,7.8,0,0,1,5.538-2.293m0-1.981A9.813,9.813,0,1,0,23,13.188a9.811,9.811,0,0,0-9.812-9.812Z" fill={fill}/>
        <path id="Trazado_2" data-name="Trazado 2" d="M20.5,19.127,19.127,20.5l-3.533-3.533L12.06,20.5l-1.373-1.373,3.533-3.533L10.688,12.06l1.373-1.373,3.533,3.533,3.533-3.533L20.5,12.06l-3.533,3.533Z" transform="translate(-2.406 -2.406)" fill={fill}/>
      </g>
    </svg>
  );
}